module.exports = __webpack_public_path__ + "assets/peoples.f0833f7f.svg";